// Timezone helpers that need nothing but `Intl`. Kept out of `utils/luxon.ts` so callers wanting
// only the detected timezone do not pull in the date library — the shell reads this on every page.
export const getDetectedTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone
